import { render } from "./UploadFileModalComponent.vue?vue&type=template&id=fdab5e36&scoped=true"
import script from "./UploadFileModalComponent.vue?vue&type=script&lang=js"
export * from "./UploadFileModalComponent.vue?vue&type=script&lang=js"

import "./UploadFileModalComponent.vue?vue&type=style&index=0&id=fdab5e36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdab5e36"]])

export default __exports__